/* eslint-disable @typescript-eslint/no-unused-vars */
import { Step, TemplateSMSAction } from 'interface/experience/experience.interface';
import { SMS_STORE_ACTION_TYPE, SMSState, SMSStateItem } from './sms.type';
import { createReducer, getSMSActionFromStep } from 'store/helper';
import { SetInstanceAction, SetTemplateAction } from 'store/templated-experience/templated-experience.type';
import { UpdateSMSAction } from 'store/actionTypes';
import { SMSStatePayload, SMSTemplatePayload } from 'interface/sms/sms.type';

const initialState: SMSState = {
  byRefId: {},
  allRefId: [],
};

export default createReducer(initialState, {
  SET_TEMPLATE: setTemplate,
  SET_INSTANCE: setInstance,
  CLEAR_JOURNEY: clearJourney,
  [SMS_STORE_ACTION_TYPE.UPDATE_SMS]: updateSMS,
});

function clearJourney() {
  return initialState;
}

function flattenSMSAction(sms: TemplateSMSAction, isTemplate = false, stepIdx = 0): SMSStateItem {
  const template: SMSStatePayload['template'] = {};

  Object.entries(sms.payload?.template ?? {}).forEach(([key, value]) => {
    template[key] = {
      providerTemplateData: isTemplate ? value.providerTemplateData : {},
      providerTemplateId: isTemplate ? value.providerTemplateId : '',
      journeySMSTemplateData: value.providerTemplateData,
      journeySMSTemplateId: value.providerTemplateId,
    };
  });

  return {
    ...sms,
    id: sms.payload?.id,
    name: sms.payload?.name,
    payloadType: sms.payload?.payloadType,
    payload: sms.payload && {
      ...sms.payload,
      template,
    },
    isOptional: isTemplate ? sms.isOptional : false,
    stepIdx,
  };
}

function setTemplate(state: SMSState, action: SetTemplateAction): SMSState {
  const preserveInstance = action.payload.preserveInstance;
  const byRefId: SMSState['byRefId'] = preserveInstance ? { ...state.byRefId } : {};
  const allRefId: SMSState['allRefId'] = preserveInstance ? [...state.allRefId] : [];

  action.payload?.template?.steps.forEach((step, idx) => {
    const sms = getSMSActionFromStep(step) as TemplateSMSAction;

    if (sms) {
      if (preserveInstance) {
        if (byRefId[sms.refId]) {
          const payload = state.byRefId[sms.refId].payload;
          const template: SMSStatePayload['template'] = payload?.template ?? {};

          sms.payload?.template &&
            Object.entries(sms.payload.template).forEach(([key, value]) => {
              template[key] = {
                ...(template[key] ?? {}),
                providerTemplateData: value.providerTemplateData,
                providerTemplateId: value.providerTemplateId,
              };
            });
          byRefId[sms.refId] = {
            ...state.byRefId[sms.refId],
            payload: payload && {
              ...payload,
              template,
            },
            isOptional: sms.isOptional,
          };
        } else {
          byRefId[sms.refId] = flattenSMSAction(sms, true, idx);
          if (!allRefId.includes(sms.refId)) {
            allRefId.push(sms.refId);
          }
        }
      } else {
        byRefId[sms.refId] = flattenSMSAction(sms, true, idx);
        if (!allRefId.includes(sms.refId)) {
          allRefId.push(sms.refId);
        }
      }
    }
  });

  return {
    byRefId,
    allRefId,
  };
}

function setInstance(state: SMSState, action: SetInstanceAction): SMSState {
  if (!action.payload.updateNewReducer) return state;
  const byRefId: SMSState['byRefId'] = {};
  const allRefId: SMSState['allRefId'] = [];

  action.payload?.instance?.steps.forEach((step: Step, idx: number) => {
    const sms = getSMSActionFromStep(step);

    if (sms) {
      byRefId[sms.refId] = flattenSMSAction(sms, false, idx);
      allRefId.push(sms.refId);
    }
  });

  return {
    ...state,
    byRefId,
    allRefId,
  };
}

function updateSMS(state: SMSState, action: UpdateSMSAction): SMSState {
  return { ...state, byRefId: { ...state.byRefId, [action.payload.refId]: action.payload } };
}
